/**
 * The UST curve at a tenor (05.4 E1's y(T)): linear in tenor years between the curve points, flat outside [3m, 10y]. Shared by the
 * mtm model (swap pricing) and the engine (a new swap's fixed rate).
 */
import type { EnvSnapshot, Rate } from "./cp1_domain";

export type CurvePointId = keyof EnvSnapshot["curveRate"];

/** The curve points' tenors in years, shortest first. */
export const CURVE_TENOR_YEARS: Readonly<Record<CurvePointId, number>> = { "3m": 0.25, "2y": 2, "5y": 5, "10y": 10 };
const POINTS = Object.entries(CURVE_TENOR_YEARS) as readonly (readonly [CurvePointId, number])[];

export function curveRateAt(env: EnvSnapshot, tenorYears: number): Rate {
  const [firstPoint, firstYears] = POINTS[0] as (typeof POINTS)[number];
  let lo = env.curveRate[firstPoint] as number;
  if (tenorYears <= firstYears) return lo as Rate;
  let loYears = firstYears;
  for (let i = 1; i < POINTS.length; i++) {
    const [point, years] = POINTS[i] as (typeof POINTS)[number];
    const hi = env.curveRate[point] as number;
    if (tenorYears <= years) return (lo + ((hi - lo) * (tenorYears - loYears)) / (years - loYears)) as Rate;
    lo = hi; loYears = years;
  }
  return lo as Rate;
}
